


<div class="row">
  <div class="col-6">
    <h2>Test Customer API Endpoints:</h2>

    <div class="endpoint">
      <strong>Get Available Templates</strong>
      <button (click)="getAllTemplate()">GET</button> api/Customers/Templates
    </div>

    <div class="endpoint">
      <strong>Get Provisioning Status:</strong>
      <button (click)="getProvisioningStatus()">GET</button> api/Customers/<input id="getProvisioningStatus-workSiteId" placeholder="WorkSiteGUID" />/ProvisioningStatus
    </div>

    <div class="endpoint">
      <strong>Get Applied Templates:</strong>
      <button (click)="getAppliedTemplates()">GET</button> api/Customers/<input id="getAppliedTemplates-workSiteId" placeholder="WorkSiteGUID" />/Templates
    </div>

    <div class="endpoint">
      <strong>Get Site Url:</strong>
      <button (click)="getSiteUrl()">GET</button> api/Customers/<input id="getSiteUrl-workSiteId" placeholder="WorkSiteGUID" />/Site
    </div>

    <div class="endpoint">
      <strong>Get Library Url:</strong>
      <button (click)="getLibraryUrl()">GET</button> api/Customers/<input id="getLibraryUrl-workSiteId" placeholder="WorkSiteGUID" />/Templates/<input id="getLibraryUrl-templateName" placeholder="TemplateName.xml" />/LibraryUrl
    </div>

    <div class="endpoint">
      <strong>Create Site:</strong>
      <button (click)="createSite()">POST</button> api/Customers/<input id="createSite-workSiteId" placeholder="WorkSiteGUID" />/Site
    </div>

    <div class="endpoint">
      <strong>Apply Template:</strong>
      <button (click)="applyTemplate()">POST</button> api/Customers/<input id="applyTemplate-workSiteId" placeholder="WorkSiteGUID" />/Templates/<input id="applyTemplate-templateName" placeholder="TemplateName.xml" />
    </div>

  </div>
  <div class="col-6">
    <h2>Result:</h2>
    <textarea id="output" class="output">{{result}}</textarea>
  </div>
</div>
